// extracted by mini-css-extract-plugin
export var galleryList = "gallery-preview-module--gallery-list--JC2LS";
export var galleryListItem = "gallery-preview-module--galleryListItem--sof2B";
export var gatsbyImageWrapper = "gallery-preview-module--gatsby-image-wrapper--VlzrY";
export var link = "gallery-preview-module--link--c1aPJ";
export var meta = "gallery-preview-module--meta---xX79";
export var title = "gallery-preview-module--title--DJqlS";